import { Alert, Box } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { loginStudent } from "../../api/student";
import { useNavigate } from "react-router-dom";
import {
  getLocalStorageValue,
  setLocalStorageValue,
} from "../../utils/localStorage";
import { loginStudentSchema } from "../../schema/studentSchema";
import { mockStudentLoginFields } from "../../data/mockStudentData";
import AuthLayout from "../global/AuthLayout";
import FormFooter from "../shared/FormFooter";
import AuthForm from "../shared/AuthForm";

const initialValues = {
  email: "",
  password: "",
};

const StudentLogin = () => {
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const result = getLocalStorageValue("student");
    if (result) {
      navigate("/studentDashboard");
    }
  }, [navigate]);

  const handleFormSubmit = useCallback(
    async (values) => {
      try {
        const studentData = await loginStudent(values);
        setLocalStorageValue("student", studentData);
        navigate("/studentDashboard");
      } catch (error) {
        setErrorMessage(error.message);
        setIsError(true);
        setTimeout(() => {
          setIsError(false);
        }, 3000);
      }
    },
    [navigate]
  );

  return (
    <AuthLayout title="Login Student">
      {isError && (
        <Box my={2}>
          <Alert variant="filled" severity="error">
            {errorMessage}
          </Alert>
        </Box>
      )}
      <AuthForm
        initialValues={initialValues}
        validationSchema={loginStudentSchema}
        fields={mockStudentLoginFields}
        onSubmit={handleFormSubmit}
      >
        <FormFooter
          text="If you don't have any account"
          link="register"
          linkText="register"
          buttonText="Login Student"
        />
      </AuthForm>
    </AuthLayout>
  );
};

export default StudentLogin;
